const AppParameters: any = "ComparatoreMFParameters";

export const environment = {
  production: true,
  version: 0,

  // baseDomain: window[AppParameters]['baseDomain'],
  // apiBaseDomain: window[AppParameters]['apiBaseDomain'],
  // nMin: window[AppParameters]['nMin'],
  // nMax: window[AppParameters]['nMax'],
  // nLimit: window[AppParameters]['nLimit'],

};
